export default __webpack_public_path__ + "static/media/Hands-pt.349dc0e0.png";